<template>
  <div>
    <b-badge class="d-flex align-items-center justify-content-between">
      <div
        v-if="file?.id"
        @click="handleDownloadFile"
        class="text-white cursor-pointer"
      >
        <div class="d-flex align-items-center">
          <i class="fa fa-download cursor-pointer"></i>
          <p class="ml-2 mb-0">Attachment</p>
        </div>
      </div>
      <a
        v-else
        :href="file?.url"
        target="_blank"
        rel="noopener noreferrer"
        class="text-white"
      >
        <div class="d-flex align-items-center">
          <i class="fa fa-download cursor-pointer"></i>
          <p class="ml-2 mb-0">Attachment</p>
        </div>
      </a>
      <i
        v-if="!isPreview"
        class="fa fa-close cursor-pointer"
        @click="onClickDelete"
      ></i>
    </b-badge>
  </div>
</template>
<script>
import { getFileExtensionUrl, previewFile } from '@/src/plugins/helpers'
import { srActions } from '@/src/Utils/helper'

export default {
  props: {
    url: '',
    isPreview: Boolean,
    modelName: '',
    modelId: null,
    file: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      apiUrl: `${process.env.VUE_APP_API_BASE_URL}/sr/`,
      loading: false,
    }
  },
  computed: {
    fileName() {
      return this.file?.path.split('/').pop()
    },
  },
  methods: {
    ...srActions,

    async handleDownloadFile() {
      const urlPath = `${this.apiUrl}${this.file?.url || this.file?.path}`
      previewFile(urlPath)
    },
    onClickDelete() {
      if (this.file?.id) {
        this.handleDeletFileSR()
      } else {
        this.$emit('delete')
      }
    },
    async handleDeletFileSR() {
      this.$swal({
        title: `Confirm for Delete File?`,
        text: `Are you sure want to to delete attachment ${this.fileName}?`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!',
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            const body = {
              model_name: this.modelName,
              id: this.modelId,
              key: this.file?.path,
            }
            const res = await this.deleteFileSr({ body })
            this.$swal('Success!', 'Success delete file.', 'success')
            this.$emit('success-delete', this.file?.path)
          } catch (err) {
            console.log(err)
            this.$swal('Failed!', 'Failed delete file.', 'error')
          }
        }
      })
    },
  },
}
</script>
